import React, { Component } from 'react';
import InputList from '../../../shared/components/presentation/input-list/InputList';
import { Grid, GridItem } from '../../../shared/components/presentation/grid/Grid';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as webAppointmentActions from '../../actions/webAppointmentActions';
import { nextPage } from '../../functions/nextPage';
import * as defaultState from '../../constants/DefaultState';

export class AppointmentInfo1Page extends Component {

  isValid() {
    let valid = this.props.appointment.reason;
    return valid;
  }

  render() {
    const title = "Tell us about " + (this.props.forMe ? "your" : "their") + " appointment needs.";

    let inputlist = [
      {
        fieldsetLegend: "",
        fieldsetColumns: 1,
        inputs: [
          {
            type: 'text-area',
            id: 'reason',
            className: 'text-area--block',
            label: 'What is the reason for this appointment?',
            required: true,
            requiredError: "Please provide the reason for this appointment request.",
            maxLength: '500',
            validateOnBlur: true,
            validationErrorClass: "web-appointment__error",
            useDiv: true,
            helperText: "Symptoms or part of the body that is affected. 500 character limit.",
            existingContent: this.props.appointment.reason || undefined,
            onChange: (ev) => { this.props.webAppointmentSetAppointmentReason(ev.target.value); }
          },
          {
            type: 'text-area',
            id: 'diagnosis',
            className: 'text-area--block',
            label: "Do " + (this.props.forMe ? "you" : "they") + " have a diagnosis? If so, please describe. (Optional)",
            maxLength: '500',
            useDiv: true,
            helperText: "Let us know " + (this.props.forMe ? "your" : "their") + " diagnosis and any related imaging or testing. 500 character limit.",
            existingContent: this.props.appointment.diagnosis || undefined,
            onChange: (ev) => { this.props.webAppointmentSetAppointmentDiagnosis(ev.target.value) }
          }
        ]
      },
      {
        fieldsetLegend: "",
        fieldsetColumns: 1,
        className: "button-order margin-top-medium",
        inputs: [
          [
            {
              type: 'button',
              id: "back",
              className: "btn--secondary",
              value: 'Back',
              onClick: () => {
                this.props.history.goBack();
              }
            },
            {
              type: 'button',
              id: "next",
              className: "btn--primary",
              value: "Next",
              disabled: !this.isValid(),
              onClick: () => {
                this.props.history.push(nextPage());
              }
            }
          ]
        ]
      }
    ];

    return (
      <React.Fragment>
        <Grid columns={1}>
          <GridItem>
            <div className='web-appt__header'>
              <h1>{title}</h1>
              <hr />
            </div>
          </GridItem>
        </Grid>
        <InputList inputs={inputlist} isInlineList={false} />
      </React.Fragment>
    );
  }
}

AppointmentInfo1Page.propTypes = {
  appointment: defaultState.appointmentProptype,
  forMe: PropTypes.bool.isRequired,
  webAppointmentSetAppointmentReason: PropTypes.func.isRequired,
  webAppointmentSetAppointmentDiagnosis: PropTypes.func.isRequired
};

function mapStateToProps(state, ownProps) {
  return {
    appointment: state.webAppointmentForm.appointment,
    forMe: state.webAppointmentForm.forMe
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    webAppointmentSetAppointmentReason: (value) => dispatch(webAppointmentActions.webAppointmentSetAppointmentReason(value)),
    webAppointmentSetAppointmentDiagnosis: (value) => dispatch(webAppointmentActions.webAppointmentSetAppointmentDiagnosis(value))
  };
};

// connects component to redux, and passes along the router
export default connect(mapStateToProps, mapDispatchToProps)(AppointmentInfo1Page);
